export default "__VITE_ASSET__CJ7jt2g$__"